import { useEffect, useRef, useState, useCallback } from "react";

const VideoPlayer = ({ videoObjects, onLog }) => {
  const videoRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef(null);

  const currentVideo = videoObjects[currentIndex];

  const fireTrackers = useCallback(
    (eventId, trackers = []) => {
      trackers
        .filter((t) => t.event === eventId)
        .forEach((t) => {
          const url = t.url.replace("[ERRORCODE]", "500");
          fetch(url).catch(() => {});
          onLog(`Tracker ${eventId}`, url);
        });
    },
    [onLog]
  );

  const handleVideoEnd = useCallback(() => {
    const nextIndex = (currentIndex + 1) % videoObjects.length;
    setCurrentIndex(nextIndex);
  }, [currentIndex, videoObjects.length]);

  useEffect(() => {
    if (!currentVideo) return;

    const video = videoRef.current;

    const play = async () => {
      try {
        await video.play();
        onLog(`(${currentIndex + 1}/${videoObjects.length})`, currentVideo.url);
        fireTrackers(1, currentVideo.trackers);
      } catch (err) {
        onLog("❌ Play Error", currentVideo.url);
        fireTrackers(511, currentVideo.trackers);
        handleVideoEnd();
      }
    };

    video.load();

    timeoutRef.current = setTimeout(() => {
      play();
    }, 10);

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [
    currentIndex,
    currentVideo,
    fireTrackers,
    handleVideoEnd,
    onLog,
    videoObjects.length,
  ]);

  return (
    <div style={{ position: "relative" }}>
      <video
        ref={videoRef}
        controls={false}
        onEnded={handleVideoEnd}
        style={{
          width: "100%",
          height: "auto",
          maxHeight: "100%",
          borderRadius: "12px",
          backgroundColor: "black",
          objectFit: "contain",
        }}
      >
        <source src={currentVideo?.url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {videoObjects.length > 1 && (
        <div
          style={{
            position: "absolute",
            bottom: 10,
            right: 10,
            backgroundColor: "rgba(0,0,0,0.7)",
            color: "#fff",
            padding: "4px 8px",
            fontSize: "0.85rem",
            borderRadius: "6px",
          }}
        >
          Uncommon Media
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
